define('lib/Podio.UI.Tasks.Composer',['require','underscore','jquery','lib/jquery/jquery.elastic','lib/jquery/jquery.timeentry','lib/Podio.UI.Tasks.Form','lib/Podio.Transport.Tasks.Create','lib/fileuploader/multi','lib/Podio.UI.SettingsBalloon','lib/Podio.UI'],function (require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.elastic');
  require('lib/jquery/jquery.timeentry');

  var TasksForm = require('lib/Podio.UI.Tasks.Form');
  var TaskCreateTransport = require('lib/Podio.Transport.Tasks.Create');
  var fileUploaderMulti = require('lib/fileuploader/multi');
  var settingsBalloon = require('lib/Podio.UI.SettingsBalloon');
  var podioUI = require('lib/Podio.UI');

  var uploaderInstance, reminderInstance, recurrenceInstance;
  var disableUploader;

  function setupTaskForm(elmForm) {
    var elmResponsible = elmForm.find('#task_responsible');
    TasksForm.setupResponsible(elmResponsible, {tokenLimit: null}, function() {
      var elmRefId = elmForm.find('#task_ref_id');
      if(elmRefId.length && elmRefId.val() !== '') { // Only filter by space if we have a ref
        return elmForm.find('#space_id').val();
      } else {
        return '';
      }
    });
    elmForm.find('#task_description').elastic();
  }

  function setupTaskFormExpanded(elmForm, options) {
    var elmDueDateSelect = elmForm.find('#due_date_select');
    var elmDueDateInputField = elmForm.find('.task_due_date');
    TasksForm.setupDueDate(elmDueDateSelect, elmDueDateInputField);
    var elmDueOnTime = elmForm.find('#task_due_time');
    elmDueOnTime.timeEntry({spinnerImage: false});
    var elmPrivate = elmForm.find('#task_private');
    TasksForm.setupPrivate(elmPrivate);

    TasksForm.setupSpacePicker(elmForm.find('#task_ref_id'), {}, elmPrivate);
    TasksForm.setupLabelList(elmForm.find('#task_label_list'), { });

    if (!options || !options.disableUploader) {
      disableUploader = true;
      uploaderInstance = fileUploaderMulti.render(elmForm.find('.attach-file-box'), {
        skin : 'tasks',
        useFileFinder: true,
        elmHiddenInput : elmForm.find('.files-hidden-input'),
        elmDropContainer : elmForm.find('.attached-files-wrapper'),
        elmListContainer : elmForm.find('.attached-files-wrapper')
      });
    }

    var elmReminderAnchor = elmForm.find("[data-settings-balloon='.task-reminder-form']");
    var elmReminderEnabled = elmForm.find('#task_reminder_enabled');
    if(elmReminderAnchor.length && elmReminderEnabled.length) {
      resetSettingBallons(elmForm);
      reminderInstance = TasksForm.setupReminder(elmReminderAnchor, elmDueDateInputField, elmDueDateSelect, elmDueOnTime, "#new_task [name='task[reminder][remind_delta]']", elmReminderEnabled);
    }

    var elmRecurrenceAnchor = elmForm.find("[data-settings-balloon='.task-recurrence-form']");
    var elmRecurrenceEnabled = elmForm.find('#task_recurrence_enabled');
    if(elmRecurrenceAnchor.length && elmRecurrenceEnabled.length) {
      recurrenceInstance = TasksForm.setupRecurrence(elmRecurrenceAnchor, elmDueDateInputField, elmDueDateSelect, elmDueOnTime, "#new_task [name='recurrence_tasks_new']", elmRecurrenceEnabled);
    }
  }

  function onTaskSubmit(callback, onSuccessCallback, elmTarget, e) {
    e.preventDefault();

    $('#new_task_container .error-failed').remove();

    //if( elmTarget.valid() ) {
    if (elmTarget.find('#task_text').val() !== '') {

      // Labels
      elmTarget.find('#label_list_new').val($('#task_label_list').attr('data-tokens-free'));
      elmTarget.find('#label_list_existing').val($('#task_label_list').attr('data-tokens-dropdown'));

      // Disable button
      var elmSubmitButton = elmTarget.find('#task_submit');
      podioUI.disableButtonWithLoader(elmSubmitButton);

      if (elmTarget.hasClass('task-modal-form') && _.isFunction(callback)) {
        callback(elmTarget);
      } else {
        // Send task to server
        TaskCreateTransport.createTask(elmTarget, function(responseData) {
          if (responseData.status === 'ok') {
            resetForm(elmTarget);
            focusTaskTextField();
            if (_.isFunction(onSuccessCallback)) {
              onSuccessCallback(responseData);
            }
          } else {
            elmTarget.before('<div class="error-failed">' + responseData.message + '</div>');
            podioUI.restoreButtonWithLoader(elmSubmitButton);
          }
        });
      }
    }
  }

  function focusTaskTextField() {
    _.delay(function() {
      if ($('.task-modal-form').length) {
        $('.task-modal-form #task_text').focus();
      } else {
        $('#task_text').focus();
      }
    },100);
  }

  function resetForm(elmForm) {
    var elmFilesInput;

    elmForm.find('input[type=text]:visible, textarea#task_description').each(function() {
      $(this).val('');
      $(this).blur();
    });
    elmForm.find('#new_task_expand_on_type').addClass('hidden');
    elmForm.find('#due_date_select:not(:disabled), #task_private:not(:disabled)').each(
      function(index, elmSelect) {
        elmSelect.selectedIndex = 0;
      }).trigger("refresh.dropdown.podio");

    if (!$('body').hasClass('space tasks')) {
      var elmPrivateSelect = $('#task_private:not(:disabled)');
      elmPrivateSelect.prop('disabled', true);
      elmPrivateSelect.trigger("disable.dropdown.podio");
      elmPrivateSelect.prop('selectedIndex', 1);
      elmPrivateSelect.trigger("refresh.dropdown.podio");
    }

    elmForm.find('.task_due_date').val('');
    elmForm.find('.task_due_date').val('');
    elmForm.find('#task_due_time').val('');
    elmForm.find('#task_responsible').trigger('reset.picker.podio');

    var elmSpaceInput = elmForm.find('#task_ref_id');
    elmSpaceInput.trigger('reset.picker.podio');
    elmSpaceInput.trigger('populate.picker.podio', [elmSpaceInput.data('prepopulate')]);

    elmForm.find('#task_label_list').trigger('reset.picker.podio');

    // clear the files
    elmFilesInput = elmForm.find('.files-hidden-input');

    if (elmFilesInput.length) {
      elmFilesInput.val('');
    }

    if(reminderInstance) {
      reminderInstance.reset();
    }

    if(recurrenceInstance) {
      recurrenceInstance.reset();
    }

    podioUI.restoreButtonWithLoader(elmForm.find('#task_submit'));

    resetUploadBox(elmForm);

    // HACK: Circumenvent placeholders plugin's timeout
    setTimeout(function() {
      $('#task_description').addClass('placeholder');
    }, 11);
  }

  function resetSettingBallons(elmForm) {
    var elmReminderAnchor = elmForm.find("[data-settings-balloon='.task-reminder-form']");
    settingsBalloon.destroy(elmReminderAnchor);

    var elmRecurrenceAnchor = elmForm.find("[data-settings-balloon='.task-recurrence-form']");
    settingsBalloon.destroy(elmRecurrenceAnchor);
  }

  function resetUploadBox(elmForm) {
    if (!disableUploader) {
      return true;
    }

    // Reset uploaders
    elmForm.find('div.upload-attachments').empty();

    if(uploaderInstance) {
      uploaderInstance.clearAll();
    }

    // Hide upload box
    var elmCommentBox = elmForm.find('.comment-box');
    elmCommentBox.addClass('hidden');
  }

  function handleModalPlaceholders(elmForm) {
    focusTaskTextField();
  }

  function onAttachFileClicked(elmTarget, e) {
    var elmForm = elmTarget.parents('form#new_task');
    var elmCommentBox = elmForm.find('.comment-box');
  }

  function refreshUploader() {
    if(uploaderInstance) {
      uploaderInstance.refresh();
    }
  }

  return {
    refreshUploader : refreshUploader,
    setupTaskForm: setupTaskForm,
    setupTaskFormExpanded: setupTaskFormExpanded,
    onTaskSubmit: onTaskSubmit,
    handleModalPlaceholders: handleModalPlaceholders,
    onAttachFileClicked: onAttachFileClicked,
    resetForm: resetForm,
    focusTaskTextField: focusTaskTextField
  };

});

